var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.active)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }